import { TransactionsContextType } from "@zenith/context/global-context/types";
import { memo } from "react";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";
import { shouldShow, isPaymentLinkUSSD, truncateText } from "@zenith/utils/TransactionDisplayHelpers";

export interface UssdTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const UssdTransactionDetails = memo(function UssdTransactionDetails(
  props: UssdTransactionDetailsProps
) {
  const { transaction } = props;
  const paymentMethodString = transaction?.paymentMethod as string;
  
  const isPaymentLinkUssd = isPaymentLinkUSSD(paymentMethodString);

  return (
    <>
      {!isPaymentLinkUssd && shouldShow(transaction?.beneficiaryName) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Payer's Name</p>
          <p className="font-medium text-neutral-900">
            {transaction?.beneficiaryName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.bankName) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Payer's Bank</p>
          <p className="font-medium text-neutral-900">
            {transaction?.bankName}
          </p>
        </div>
      )}

      {/* {shouldShow(transaction?.beneficiaryAccountNumber) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Payer's Account</p>
          <CopyToClipboard text={transaction?.beneficiaryAccountNumber} />
        </div>
      )} */}

      {shouldShow(transaction?.transferAccountNumber) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Merchant Account</p>
          <CopyToClipboard text={transaction?.transferAccountNumber} />
        </div>
      )}

      {shouldShow(transaction?.sessionId) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Session ID</p>
          <CopyToClipboard text={transaction?.sessionId} />
        </div>
      )}

      {shouldShow(transaction?.operationCode) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">USSD String</p>
          <p className="font-medium text-neutral-900">
            {transaction?.operationCode}
          </p>
        </div>
      )}

      {shouldShow(transaction?.description) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Description</p>
          <div className="w-3/5 text-right">
            <p className="font-medium text-neutral-900 break-words">
              {truncateText(transaction?.description)}
            </p>
          </div>
        </div>
      )}
    </>
  );
});

export default UssdTransactionDetails;